import { create } from 'zustand';

export type ThemeMode = 'antd' | 'md3';

const STORAGE_KEY = 'theme';
const BODY_CLASS = 'theme-md3';

const readInitial = (): ThemeMode => {
  if (typeof window === 'undefined') return 'md3';
  const v = window.localStorage.getItem(STORAGE_KEY);
  // Дефолт — Material 3. В localStorage сохраняется только явный выбор пользователя.
  return v === 'antd' ? 'antd' : 'md3';
};

const applyBodyClass = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return;
  if (mode === 'md3') document.body.classList.add(BODY_CLASS);
  else document.body.classList.remove(BODY_CLASS);
};

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggle: () => void;
}

const initial = readInitial();
applyBodyClass(initial);

const useThemeStore = create<ThemeState>((set, get) => ({
  mode: initial,
  setMode: (mode) => {
    window.localStorage.setItem(STORAGE_KEY, mode);
    applyBodyClass(mode);
    set({ mode });
  },
  toggle: () => {
    const next: ThemeMode = get().mode === 'md3' ? 'antd' : 'md3';
    get().setMode(next);
  },
}));

export default useThemeStore;
